import React from 'react'
import { useState, useEffect } from 'react';
import XCircleFillIcon from '../../../assets/icons/XCircleFill';
import { useCountryCodeMutation, useEditEmployeeMutation } from '../api/employeeApi';
import { employeeFormValidation } from '../../../utils/formValidation';
import Toast from '../../../components/ToastNotification';
import Select from 'react-select';

const EditEmployee = ({ companyInfo, selectedRow, paginationState, onClose }) => {
  const { id, name, country_code, phone_number: phone } = selectedRow;
  const [formData, setFormData] = useState({ company_id: companyInfo?.id, name, country_code, phone });
  const [errorMessage, setErrorMessage] = useState();
  const [validationError, setValidationError] = useState(null);
  const [countryCodeData, setCountrytCodeData] = useState([]);
  const [editEmployeeApi] = useEditEmployeeMutation();
  const [countryCodeApi] = useCountryCodeMutation();

  const handleSubmit = async(e) => {
    e.preventDefault();
    try {
      const validationResult = employeeFormValidation(formData);
      if (validationResult?.errorMessage) {
        setErrorMessage('');
        setValidationError(validationResult.errorMessage);
        return;
      }

      await editEmployeeApi({...validationResult.data, id}).unwrap();
      paginationState.setPagination({
        ...paginationState.pagination,
        pageIndex: 0
      });

      Toast.success('Employee updated successfully');
      onClose();
      
    } catch (err) {
      setValidationError(null);
      setErrorMessage(err?.data?.message || err?.message || err?.error || 'Failed to fetch')
    }
  }

  const fetchCountryCodes = async() => {
      try {
        const countryCodes = await countryCodeApi().unwrap();
        if (countryCodes?.data) {
          const formattedData = countryCodes.data.map(c => ({
            value: c.dial_code,
            label: (
              <div className='country-label'>
                <img src={c.flag} alt={c.name} className="flag-icon" />
                <span>{c.dial_code}</span>
              </div>
            )
          }));
          setCountrytCodeData(formattedData);
        }
      } catch (error) {
        setCountrytCodeData([]);
      }
    }
  
    useEffect(()=> {
      fetchCountryCodes();
    }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  }

  const handleCountrySelect = (selectedOption) => {
    setFormData(prev => ({
      ...prev,
      country_code: selectedOption?.value || ''
    }));
  };

  return (
    <div className='overlay' onClick={onClose}>
      <div className='content_layout' onClick={(e) => e.stopPropagation()}>
        <div className='content_header'>
          <h2>Edit Employee</h2>
          {errorMessage && <p className="error-message">{errorMessage}</p>}
          <button className='close-btn' onClick={onClose}><XCircleFillIcon size={24} /></button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className='form-group'>
            <label htmlFor="name">Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter Name"
              value={formData.name}
              onChange={handleChange}
            />
            {validationError?.name && <p className="error-message">{validationError.name}</p>}
          </div>
          <div className='form-group'>
            <label htmlFor="country code">Select Country Code</label>
              <Select
                options={countryCodeData}
                placeholder="Select Country Code"
                className="w-44"
                formatOptionLabel={(option) => option.label}
                onChange={handleCountrySelect}
                value={
                  countryCodeData.find(opt => opt.value === formData.country_code) || null
                }
              />
              {validationError?.country_code && <p className="error-message">{validationError.country_code}</p>}
          </div>
          <div className='form-group'>
            <label htmlFor="phone">Phone Number</label>
              <input
                type="text"
                name="phone"
                placeholder="Enter Phone Number"
                value={formData.phone}
                onChange={handleChange}
                className='flex-1'
              />
              {validationError?.phone && <p className="error-message">{validationError.phone}</p>}
          </div>
          <div className='layout_footer'>
            <button type="submit" className='save-btn'>Save</button>
            <button onClick={onClose} className='cancel-btn'>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditEmployee;
